import React from 'react';
import { WorkflowStatus } from '../types';
import { Check, Clock, AlertCircle, Settings } from 'lucide-react';
interface WorkflowProgressProps {
  currentStatus: WorkflowStatus;
}
const steps = [{
  id: 'upload',
  label: 'ডাটা সাবমিশন'
}, {
  id: 'validate',
  label: 'যাচাইকরণ'
}, {
  id: 'process',
  label: 'প্রক্রিয়াকরণ'
}, {
  id: 'approve',
  label: 'অনুমোদন'
}, {
  id: 'publish',
  label: 'প্রকাশনা'
}];
export const WorkflowProgress: React.FC<WorkflowProgressProps> = ({
  currentStatus
}) => {
  const getStepStatus = (stepIndex: number) => {
    const statusMap: Record<WorkflowStatus, number> = {
      pending_validation: 1,
      processing: 2,
      error: 2,
      ready_for_approval: 3,
      approved: 4,
      published: 4,
      rejected: 1 // Sent back
    };
    const currentIndex = statusMap[currentStatus];
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) {
      if (currentStatus === 'error' || currentStatus === 'rejected') return 'error';
      return 'current';
    }
    return 'upcoming';
  };
  return <div className="w-full py-4" data-id="element-204">
      <div className="flex items-center justify-between relative" data-id="element-205">
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-1 bg-slate-200 -z-10" data-id="element-206"></div>

        {steps.map((step, index) => {
        const status = getStepStatus(index);
        return <div key={step.id} className="flex flex-col items-center relative z-10" data-id="element-207">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 mb-2 bg-white
                  ${status === 'completed' ? 'border-teal-500 bg-teal-50 text-teal-600' : status === 'current' ? 'border-blue-600 bg-blue-50 text-blue-600' : status === 'error' ? 'border-red-500 bg-red-50 text-red-600' : 'border-slate-300 text-slate-400'}`} data-id="element-208">
                {status === 'completed' && <Check size={16} data-id="element-209" />}
                {status === 'current' && currentStatus === 'processing' && <Settings size={16} className="animate-spin" data-id="element-210" />}
                {status === 'current' && currentStatus !== 'processing' && <Clock size={16} data-id="element-211" />}
                {status === 'error' && <AlertCircle size={16} data-id="element-212" />}
                {status === 'upcoming' && <span className="text-xs font-medium" data-id="element-213">{index + 1}</span>}
              </div>
              <span className={`text-xs font-medium ${status === 'upcoming' ? 'text-slate-400' : 'text-slate-700'}`} data-id="element-214">
                {step.label}
              </span>
            </div>;
      })}
      </div>
    </div>;
};